import { createRouter, createWebHistory } from 'vue-router'
import { defineAsyncComponent } from 'vue'
import activityRoutes from './modules/activity'

// 带加载提示的异步组件
const asyncComponent = (path) => {
  return defineAsyncComponent({
    loader: () => import(path),
    loadingComponent: defineAsyncComponent(() => import('../components/LoadingComponent.vue')),
    errorComponent: defineAsyncComponent(() => import('../components/ErrorComponent.vue')),
    delay: 200,
    timeout: 3000
  })
}

const routes = [
  {
    path: '/',
    redirect: '/'
  },
  // 添加活动模块路由
  ...activityRoutes,
  // 图片代理路由
  // {
  //   path: '/yyh5',
  //   name: 'ImageProxy',
  //   component: () => import('../components/ImageProxy.vue'),
  //   meta: {
  //     title: '图片动态化'
  //   }
  // },
  // page2 路由配置
  // {
  //   path: '/page2',
  //   name: 'Page2',
  //   component: () => import('../pages/page2/App.vue'),
  //   meta: {
  //     title: '页面2'
  //   }
  // },
  // 404 路由
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: 'NotFound',
  //   component: asyncComponent('../views/NotFound.vue')
  // },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
